// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductSlider_wrapper__zjrwo","wrapper__item":"ProductSlider_wrapper__item__K6jpF","wrapper__title":"ProductSlider_wrapper__title__Q3kNU"};